import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  const lastUpdate = "9 janvier 2026";
  const [expandedSection, setExpandedSection] = useState(null);

  const sections = [
    {
      icon: "📋",
      title: "1. Données collectées",
      content: `DJAMANN collecte les données suivantes pour assurer le bon fonctionnement de la plateforme :

📝 Données d'inscription (obligatoires) :
• Nom complet
• Adresse email (sert d'identifiant unique)
• Mot de passe (crypté avec bcrypt)
• Date de naissance (vérification de l'âge minimum de 16 ans)

👤 Données de profil (optionnelles) :
• Photo de profil
• Biographie / Description
• Compétences et expertises
• Localisation (ville, pays)
• Numéro de téléphone
• Liens vers réseaux sociaux

💼 Données d'activité :
• Projets créés ou rejoints
• Services proposés dans votre boutique
• Candidatures soumises
• Tâches assignées et complétées
• Historique des transactions financières
• Messages échangés sur la plateforme
• Fichiers uploadés (images, documents)

🔧 Données techniques :
• Adresse IP de connexion
• Type de navigateur et appareil
• Système d'exploitation
• Dates et heures de connexion
• Pages visitées
• Préférences de langue`
    },
    {
      icon: "🎯",
      title: "2. Utilisation des données",
      content: `Vos données sont utilisées exclusivement pour :

✅ Services essentiels :
• Créer et gérer votre compte utilisateur
• Permettre les collaborations et mises en relation
• Afficher votre profil et boutique publics
• Traiter les paiements et abonnements
• Calculer les commissions dues
• Envoyer des notifications importantes (candidatures, messages, etc.)

✅ Amélioration de la plateforme :
• Analyser l'utilisation pour améliorer l'expérience
• Développer de nouvelles fonctionnalités
• Personnaliser le feed "Pour Toi" selon vos intérêts
• Corriger les bugs et problèmes techniques

✅ Sécurité :
• Prévenir les fraudes et abus
• Vérifier l'identité des utilisateurs
• Protéger contre les accès non autorisés

❌ Nous n'utilisons PAS vos données pour :
• Les vendre à des tiers
• Vous envoyer du spam ou publicités non sollicitées
• Faire du profilage à des fins publicitaires externes
• Partager avec des courtiers en données`
    },
    {
      icon: "🔒",
      title: "3. Protection des données",
      content: `DJAMANN met en œuvre des mesures de sécurité robustes :

🛡️ Sécurité technique :
• Chiffrement des mots de passe (bcrypt)
• Connexions sécurisées HTTPS/TLS
• Tokens JWT pour l'authentification
• Protection contre les injections SQL
• Protection CSRF et XSS
• Pare-feu et surveillance des serveurs

🔐 Sécurité des paiements :
• Vos informations bancaires ne sont JAMAIS stockées sur nos serveurs
• Traitement via partenaires certifiés PCI-DSS
• Tokenisation des cartes bancaires

👥 Sécurité organisationnelle :
• Accès restreint aux données personnelles
• Formation du personnel à la protection des données
• Audits de sécurité réguliers
• Procédures en cas de violation de données

📧 Sécurité des communications :
• Emails transactionnels uniquement
• Option de désinscription aux notifications non essentielles`
    },
    {
      icon: "🤝",
      title: "4. Partage des données",
      content: `Vos données peuvent être partagées dans les cas suivants :

👥 Avec les autres utilisateurs :
• Nom et profil public visibles par tous
• Coordonnées partagées uniquement avec vos collaborateurs directs
• Informations de boutique visibles publiquement (si activée)
• Candidatures visibles par les auteurs de projets

💳 Avec nos partenaires de paiement :
• Orange Money, MTN Money, Wave, Moov Money
• Banques partenaires
• Uniquement les données nécessaires à la transaction

🏛️ Avec les autorités :
• Si requis par la loi ivoirienne
• En cas d'enquête judiciaire
• Pour protéger les droits de DJAMANN ou des utilisateurs

🔧 Avec nos prestataires techniques :
• Hébergement cloud (serveurs sécurisés)
• Services d'envoi d'emails
• Sous contrat de confidentialité strict

🚫 JAMAIS vendu à des tiers
🚫 JAMAIS partagé avec des publicitaires
🚫 JAMAIS utilisé pour du marketing externe`
    },
    {
      icon: "⏰",
      title: "5. Conservation des données",
      content: `Durées de conservation de vos données :

📂 Compte actif :
• Données conservées tant que votre compte existe
• Mises à jour possibles à tout moment

🗑️ Après suppression du compte :
• 30 jours de délai de grâce (possibilité de récupération)
• Suppression définitive après 30 jours
• Certaines données peuvent être anonymisées pour statistiques

📊 Données financières :
• Transactions : 10 ans (obligation légale comptable)
• Factures et reçus : 10 ans
• Historique des abonnements : 5 ans

📝 Logs et données techniques :
• Logs de connexion : 1 an
• Logs de sécurité : 2 ans
• Statistiques anonymisées : indéfiniment

💬 Communications :
• Messages : conservés tant que les deux parties ont un compte actif
• Notifications : 90 jours`
    },
    {
      icon: "✅",
      title: "6. Vos droits",
      content: `En tant qu'utilisateur de DJAMANN, vous disposez des droits suivants :

📖 Droit d'accès :
• Consulter toutes vos données personnelles
• Demander une copie de vos données

✏️ Droit de rectification :
• Corriger vos données inexactes
• Compléter vos données incomplètes
• Modifier votre profil à tout moment

🗑️ Droit à l'effacement :
• Supprimer votre compte et vos données
• Demander la suppression de contenus spécifiques

📦 Droit à la portabilité :
• Exporter vos données dans un format standard
• Recevoir vos données dans un délai de 30 jours

🛑 Droit d'opposition :
• Vous opposer à certains traitements
• Refuser les communications marketing

⚙️ Droit à la limitation :
• Demander la limitation du traitement dans certains cas

📧 Comment exercer vos droits :
• Paramètres du compte → section "Mes données"
• Email : privacy@djamann.com
• Délai de réponse : 30 jours maximum`
    },
    {
      icon: "🍪",
      title: "7. Cookies et traceurs",
      content: `DJAMANN utilise des cookies pour améliorer votre expérience :

🔧 Cookies essentiels (obligatoires) :
• Authentification et session utilisateur
• Sécurité (protection CSRF)
• Préférences de langue
• Panier d'achat (si applicable)

📊 Cookies analytiques (optionnels) :
• Statistiques d'utilisation anonymisées
• Amélioration de la performance
• Identification des bugs

💡 Cookies fonctionnels :
• Mémorisation de vos préférences
• Personnalisation de l'interface
• Fonctionnalités sociales

⚙️ Gestion des cookies :
• Paramétrable dans les paramètres de votre navigateur
• Certains cookies essentiels ne peuvent être désactivés
• La désactivation peut affecter certaines fonctionnalités

📱 Technologies similaires :
• LocalStorage pour les préférences
• SessionStorage pour les données temporaires`
    },
    {
      icon: "👶",
      title: "8. Protection des mineurs",
      content: `DJAMANN prend la protection des mineurs très au sérieux :

🔞 Âge minimum :
• 16 ans requis pour créer un compte
• Vérification de la date de naissance à l'inscription

👨‍👩‍👧 Utilisateurs de 16-18 ans :
• Utilisation sous responsabilité parentale
• Certaines fonctionnalités financières peuvent être limitées
• Recommandation de supervision parentale

🚫 Moins de 16 ans :
• Interdiction formelle d'utiliser la plateforme
• Comptes supprimés si découverts
• Aucune collecte intentionnelle de données

📢 Signalement :
• Si vous pensez qu'un mineur de moins de 16 ans utilise DJAMANN
• Contactez-nous : mineurs@djamann.com
• Traitement prioritaire de ces signalements`
    },
    {
      icon: "🌍",
      title: "9. Transfert international des données",
      content: `DJAMANN opère principalement en Côte d'Ivoire :

🏠 Stockage principal :
• Serveurs situés en Afrique de l'Ouest
• Conformité aux lois ivoiriennes sur les données personnelles

🌐 Transferts potentiels :
• Partenaires de paiement internationaux
• Services cloud (avec garanties de protection)
• Uniquement si nécessaire au fonctionnement du service

🛡️ Garanties :
• Clauses contractuelles types
• Évaluation du niveau de protection
• Chiffrement des données en transit

🚀 Expansion future :
• Extension vers d'autres pays africains prévue
• Conformité aux réglementations locales assurée
• Notification préalable des utilisateurs concernés`
    },
    {
      icon: "⚠️",
      title: "10. Violation de données",
      content: `En cas de violation de données personnelles :

🚨 Notre engagement :
• Notification aux autorités dans les 72h
• Notification aux utilisateurs concernés sans délai
• Mise en place de mesures correctives immédiates

📋 Informations communiquées :
• Nature de la violation
• Données potentiellement concernées
• Mesures prises pour limiter l'impact
• Recommandations pour vous protéger

🛡️ Prévention :
• Surveillance continue de nos systèmes
• Tests de pénétration réguliers
• Mise à jour des systèmes de sécurité
• Formation continue de nos équipes`
    },
    {
      icon: "📝",
      title: "11. Modifications de cette politique",
      content: `Cette politique de confidentialité peut être mise à jour :

📅 Raisons de modification :
• Évolution des lois et réglementations
• Nouvelles fonctionnalités de la plateforme
• Amélioration de la protection des données
• Changements de nos pratiques

📢 Notification :
• Email pour les changements importants
• Notification dans l'application
• Affichage de la date de mise à jour

✅ Acceptation :
• L'utilisation continue vaut acceptation
• Possibilité de supprimer votre compte si désaccord
• Historique des versions disponible sur demande`
    },
    {
      icon: "📞",
      title: "12. Contact et réclamations",
      content: `Pour toute question concernant vos données :

📧 Contact principal :
• Email : privacy@djamann.com
• Délai de réponse : 72h ouvrées

📍 Adresse :
• DJAMANN SAS
• Abidjan, Côte d'Ivoire

🏛️ Autorité de contrôle :
• ARTCI (Autorité de Régulation des Télécommunications de Côte d'Ivoire)
• Vous pouvez déposer une réclamation auprès de l'autorité compétente

📋 Informations à fournir :
• Votre nom et email associé au compte
• Description claire de votre demande
• Tout document utile à son traitement`
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Retour
          </Link>
          <div className="flex items-center gap-4 mb-4">
            <img src="/logo.png" alt="DJAMANN" className="w-12 h-12 rounded-xl" />
            <h1 className="text-3xl font-bold">Politique de Confidentialité</h1>
          </div>
          <p className="text-white/80">
            Dernière mise à jour : {lastUpdate}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* Introduction */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <span className="text-2xl">🛡️</span>
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">Votre vie privée est notre priorité</h2>
              <p className="text-gray-600 leading-relaxed">
                Chez DJAMANN, nous nous engageons à protéger vos données personnelles avec le plus grand soin. 
                Cette politique explique de manière transparente quelles informations nous collectons, 
                comment nous les utilisons, et quels sont vos droits. Nous croyons que vous devez garder 
                le contrôle total de vos données.
              </p>
            </div>
          </div>
        </div>

        {/* Quick Summary */}
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8 mb-8 border border-indigo-100">
          <h2 className="text-lg font-bold text-gray-800 mb-4">📌 En résumé</h2>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start gap-3">
              <span className="text-green-500 mt-0.5">✓</span>
              <span>Nous collectons uniquement les données nécessaires au fonctionnement de la plateforme</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500 mt-0.5">✓</span>
              <span>Nous ne vendons <strong>JAMAIS</strong> vos données à des tiers</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500 mt-0.5">✓</span>
              <span>Vos mots de passe sont cryptés et vos paiements 100% sécurisés</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500 mt-0.5">✓</span>
              <span>Vous pouvez consulter, modifier ou supprimer vos données à tout moment</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500 mt-0.5">✓</span>
              <span>Âge minimum requis : <strong>16 ans</strong></span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500 mt-0.5">✓</span>
              <span>Données stockées sur des serveurs sécurisés conformes aux normes</span>
            </li>
          </ul>
        </div>

        {/* Table of contents */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
          <h2 className="text-lg font-bold text-gray-800 mb-4">📑 Sommaire</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {sections.map((section, index) => (
              <button
                key={index}
                onClick={() => setExpandedSection(index)}
                className="text-left px-3 py-2 text-sm text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors flex items-center gap-2"
              >
                <span>{section.icon}</span>
                <span>{section.title.replace(/^\d+\.\s*/, '')}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-sm border transition-all duration-300 ${
                expandedSection === index ? 'border-purple-300 shadow-md' : 'border-gray-100 hover:shadow-md'
              }`}
            >
              <button
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                className="w-full p-8 text-left flex items-center justify-between gap-4"
              >
                <h2 className="text-xl font-bold text-gray-800 flex items-center gap-3">
                  <span className="w-10 h-10 bg-purple-100 rounded-xl flex items-center justify-center text-xl">
                    {section.icon}
                  </span>
                  {section.title.replace(/^\d+\.\s*/, '')}
                </h2>
                <svg 
                  className={`w-5 h-5 text-gray-400 transition-transform ${expandedSection === index ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${expandedSection === index ? 'max-h-[3000px]' : 'max-h-0'}`}>
                <div className="px-8 pb-8 text-gray-600 leading-relaxed whitespace-pre-line">
                  {section.content}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-12 bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
          <span className="text-4xl mb-4 block">💬</span>
          <h2 className="text-xl font-bold text-gray-800 mb-2">Des questions sur vos données ?</h2>
          <p className="text-gray-600 mb-6">
            Notre équipe dédiée à la protection des données est à votre disposition 
            pour répondre à toutes vos questions.
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link 
              to="/terms" 
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors font-medium"
            >
              📜 Conditions d'utilisation
            </Link>
            <Link 
              to="/guide" 
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors font-medium"
            >
              📖 Guide utilisateur
            </Link>
            <Link 
              to="/register" 
              className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-xl hover:from-purple-700 hover:to-indigo-700 transition-colors font-medium"
            >
              🚀 Créer un compte
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
